const variants = {
	hidden: {
		x: "-100vw",
	},
	visible: i =>  ({
		x: 0,
		transition: {
			type: "spring",
			bounce: 0.20,
			ease: "easeOut",
			duration: 0.7,
			delay: i
		},
	}),
};

export default variants;
